export default {
  title: "Homemover App"
};
